'use strict';

bbw.model.Forum = bbw.model.PubPostsManager.extend({

    include: bbw.model.ForumAreasTrait,

    areas: undefined,

    adminOnlyAreas: undefined,
    descs: undefined,
    subtypesArray: undefined,

    _getPostsType: function() {
        return 'forum';
    },

    showCreatePost: function() {
        return bbw.userIsModerator || !this.isAdminOnlyAreaSelected();
    },

    isAdminOnlyAreaSelected: function() {
        return this.adminOnlyAreas.indexOf(+this.subtype) >= 0;
    },

    _initSubtypes: function() {
        return this.loadForumAreas();
    }

});
